import type { Attachment } from '@medplum/fhirtypes'
import {
  type AttachmentConversionStatus,
  getAttachmentConversionState,
} from '@seen/core/attachmentConversion'

export interface AttachmentConversionUiState {
  status: AttachmentConversionStatus | 'ready'
  startedAt?: string
}

export function useAttachmentConversionStatus(
  attachment: Attachment | undefined
): AttachmentConversionUiState {
  if (!attachment) {
    return { status: 'ready' }
  }
  const state = getAttachmentConversionState(attachment)
  if (!state) {
    return { status: 'ready' }
  }
  return { status: state.status, startedAt: state.startedAt }
}
